export interface AEMRelatedLinkImage {
  alt: string;
  src: string;
}

export interface AEMRelatedLink {
  id: string;
  image: AEMRelatedLinkImage;
  label: string;
  url: string;
}

export interface AEMRelatedLinks {
  relatedLinkList: AEMRelatedLink[];
}
